module.exports = __webpack_public_path__ + "src/assets/img/second_icon_3.39d0b85f.svg";